import { render, staticRenderFns } from "./UnauthorizedView.vue?vue&type=template&id=1cf12956"
import script from "./UnauthorizedView.vue?vue&type=script&lang=js"
export * from "./UnauthorizedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports